/** Persistent top bar: app logo, app name, and a user avatar. */
import type { ReactNode } from 'react';

export interface TopBarProps {
  /** Human readable title shown next to the logo, e.g. the app name. */
  title: string;
  /** Initials shown in the avatar circle, e.g. `"CD"`. Omitted before login. */
  userInitials?: string | undefined;
  /**
   * Interactive avatar rendered instead of the static initials, e.g. the
   * account {@link UserMenu}. Kept as a slot so this bar stays presentational
   * and free of routing or auth concerns.
   */
  userMenu?: ReactNode;
}

/**
 * Render the app's top bar.
 *
 * @param props - Title, and either an avatar menu or initials.
 * @returns The top bar element.
 */
export function TopBar({ title, userInitials, userMenu }: TopBarProps) {
  return (
    <header className="ui-topbar">
      <div className="ui-topbar__inner">
        <img className="ui-topbar__logo" src="/branding/logo-lfi-blanc.png" alt="" />
        <span className="ui-topbar__title">{title}</span>
        {userMenu ?? null}
        {!userMenu && userInitials ? (
          <span className="ui-topbar__avatar" aria-hidden="true">
            {userInitials}
          </span>
        ) : null}
      </div>
    </header>
  );
}
